// LOGIN
export const POST_LOGIN = "/user/login";
export const POST_LOGIN_OTP = "/user/loginwithotp";
export const CHANGE_PASSWORD = "/user/changepassword";
export const PUT_PROFILE = "/user/updateProfile";
export const POST_SOCIAL_LOGIN = "/user/social-login";
export const POST_CHANGE_PASSWORD = "/user/changepassword";
export const POST_EDIT_PROFILE = "/user/update-profile";
export const POST_SET_PASSWORD = "/user/set-password";

// SIGNUP
export const POST_REGISTER = "/user/signup";

//verify OTP
export const POST_VERIFY_EMAIL = "/user/forgotPassword";

export const POST_RESET_PASSWORD = "/user/resetpassword";

//Send OTP
export const POST_SEND_OTP = "/user/sendotp";
export const POST_VERIFY_OTP = "/user/verifyotp";

//Forget Password
export const FORGET_PASSWORD = "/user/forgotpassword";

//Get All Pairs
export const GET_ALL_PAIRS_LIST = "/pair/user/getAllPairs";

// File
export const POST_FILE = "/file/add";
export const POST_REMOVE_FILE = "/file/remove";

export const POST_UPLOAD_PROFILE_IMG = "/user/uploadProfileImage";

export const POST_DELETE_PROFILE_IMG = "/user/remove-profile-image";

// Settings
export const GET_SETTINGS = "/setting/frontend-view";
export const GET_FAQS = "/faq/list";

//Transactions
export const GET_TRANSACTIONS = "/transaction/list/history";
export const ADD_TRANSACTION = "/transaction/add/history";

export const GET_TOP_TRADE_PAIRS = "/pair/user/topTradePairs";

//Home
export const POST_JOIN_US = "/subscriber/add";

export const GET_CURRENCY = "/currency/list";
export const GET_CRYPTO = "/crypto/list";

//Kyc
export const POST_GET_KYC_DETAIL = "/user/kyc/details";

export const POST_GET_KYC_STATUS = "/user/check-kyc-verification";

export const POST_GET_USER_PROFILE = "/user/get-profile-by-id";

export const POST_ASSET_WITHDRAW = "/user/vault/withdraw";

export const ASSET_WITHDRAW_HISTORY = "/user/transactions-history";

export const GET_CONTENT = "/pages/view/";

export const TRANSACTION_HISTORY = "/user/buy-sell-report";

export const GET_UNIRAMP_QUOTE_LIST = "/uniramp/get-quote-list";

export const CREATE_UNIRAMP_TRANSACTION = "/uniramp/create-transaction";

export const GET_BLOGS = "/blog/get-blog-withFilter";
export const GET_BLOGS_BY_SLUG = "/blog/get-blog-bySlug/";

export const ADD_FAV = "/user/add-fav-token";
export const GET_FAV = "/user/list-fav-token";
